import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BreakdownRow } from '../models/sla.models';
import { pctMet, sumCounts } from '../sla-rules';
import { PctChip } from './pct-chip';

/**
 * The standard Exec Dashboard count table:
 * rows by priority / category / type / team / BU, with a computed Total row
 * and a color-banded % Met SLA column — same columns as the sheet.
 */
@Component({
  selector: 'app-breakdown-table',
  imports: [PctChip],
  template: `
    <div class="table-scroll">
      <table class="sla-table">
        <thead>
          <tr>
            <th class="row-label" scope="col">{{ rowHeader() }}</th>
            <th scope="col" title="Total tickets">Total</th>
            <th scope="col" title="Closed tickets">Closed</th>
            <th scope="col">Met SLA</th>
            <th scope="col">Missed SLA</th>
            <th scope="col" title="Met SLA – WIP">Met WIP</th>
            <th scope="col" title="Missed SLA – WIP">Missed WIP</th>
            <th scope="col">% Met SLA</th>
          </tr>
        </thead>
        <tbody>
          @for (r of rows(); track r.label) {
            <tr [class.zero-row]="r.total === 0">
              <td class="row-label">{{ r.label }}</td>
              <td class="num">{{ r.total }}</td>
              <td class="num">{{ r.closed }}</td>
              <td class="num">{{ r.met }}</td>
              <td class="num">{{ r.missed }}</td>
              <td class="num">{{ r.metWip }}</td>
              <td class="num">{{ r.missedWip }}</td>
              <td class="pct"><app-pct-chip [pct]="pctMet(r)" /></td>
            </tr>
          }
        </tbody>
        @if (showTotal()) {
          <tfoot>
            <tr>
              <td class="row-label">Total</td>
              <td class="num">{{ total().total }}</td>
              <td class="num">{{ total().closed }}</td>
              <td class="num">{{ total().met }}</td>
              <td class="num">{{ total().missed }}</td>
              <td class="num">{{ total().metWip }}</td>
              <td class="num">{{ total().missedWip }}</td>
              <td class="pct"><app-pct-chip [pct]="pctMet(total())" /></td>
            </tr>
          </tfoot>
        }
      </table>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreakdownTable {
  readonly rowHeader = input.required<string>();
  readonly rows = input.required<BreakdownRow[]>();
  readonly showTotal = input(true);

  protected readonly total = computed(() => sumCounts(this.rows()));
  protected readonly pctMet = pctMet;
}
